/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import { logout, getUserName, getUserData } from "../../services/auth";
import { Sidebar } from "./Sidebar";
import userMaleIcon from "../../assets/images/user-male-icon.png";

const Layout = (props) => {
	const {
		menuActive,
		pageTitle,
		enableSearchBar,
		searchPlaceholder,
		searchTerm,
		searchOnChange,
		handleSearch,
		children,
	} = props;
	const userId = getUserData()
	const [shouldLogout, setShouldLogout] = useState(false);
	const [isOpenSidebar, setIsOpenSidebar] = useState(false);
	const [isOpenNavbarUser, setIsOpenNavbarUser] = useState(false);

	const handleLogout = useCallback((e) => {
		e.preventDefault();
		setShouldLogout(true);
		logout();
	}, []);

	if (shouldLogout) {
		return <Redirect to="/" push />;
	}
	const getURLPhoto = (_id) =>
		`https://rxy-imagens.s3.amazonaws.com/vendedores_fotos/${_id}.jpeg`;

	return (
		<div className="app app-blue">
			<React.Fragment>
				<Sidebar
					menuActive={menuActive}
					isOpenSidebar={isOpenSidebar}
					setIsOpenSidebar={setIsOpenSidebar}
				/>

				<div className="app-container">
					<nav className="navbar navbar-default active" id="navbar">
						<div className="container-fluid">
							<div className="navbar-collapse collapse in">
								<ul className="nav navbar-nav navbar-mobile">
									<li>
										<button
											type="button"
											className="sidebar-toggle"
											onClick={() => {
												setIsOpenSidebar(
													!isOpenSidebar,
												);
											}}
										>
											<i className="fa fa-bars"></i>
										</button>
									</li>
									<li className="logo">
										<a className="navbar-brand" href="#">
											<span className="highlight">
												Cartão
											</span>{" "}
											Express
										</a>
									</li>
									<li>
										<button
											type="button"
											className="navbar-toggle"
											onClick={() => {
												setIsOpenNavbarUser(
													!isOpenNavbarUser,
												);
											}}
										>
											<img
												className="profile-img"
												src={getURLPhoto(
													userId._id
												)}
												alt="Imagem do perfil"
											/>
										</button>
									</li>
								</ul>
								<ul
									className="nav navbar-nav navbar-left"
									id="search-bar"
								>
									<li className="navbar-title">
										{pageTitle}
									</li>
									{enableSearchBar ? (
										<li className="navbar-search">
											<input
												id="search"
												type="text"
												placeholder={
													searchPlaceholder ||
													"Procurar..."
												}
												value={searchTerm}
												onChange={searchOnChange}
												onKeyDown={(e) =>
													e.key === "Enter"
														? handleSearch()
														: null
												}
											/>
											<button
												className="btn-search"
												onClick={handleSearch}
											>
												<i className="fa fa-search"></i>
											</button>
										</li>
									) : null}
								</ul>
								<ul
									className="nav navbar-nav navbar-right"
									style={
										isOpenNavbarUser
											? {
													display: "block",
													height: "150px",
												}
											: {}
									}
								>
									<li className="dropdown profile">
										<a
											href="#"
											className="dropdown-toggle hidden-sm"
											data-toggle="dropdown"
										>
											<img
												className="profile-img"
												src={getURLPhoto(
													userId._id
												)}
												alt=""
											/>
											<div className="title">Profile</div>
										</a>
										<div
											ref={(element) => {
												if (isOpenNavbarUser) {
													if (element)
														element.style.setProperty(
															"display",
															"block",
															"important",
														);
												}
											}}
											className="dropdown-menu"
											style={
												isOpenNavbarUser
													? {
															visibility:
																"visible",
															opacity: 1,
															position:
																"absolute",
															top: 0,
															left: 0,
														}
													: {}
											}
										>
											<div className="profile-info">
												<h4 className="username">
													{getUserName()}
												</h4>
											</div>
											<ul className="action">
												<li>
													<a
														href="#"
														style={{
															color: "#ccc",
															cursor: "not-allowed",
														}}
														onClick={(e) => {
															e.preventDefault();
														}}
													>
														Configurações
													</a>
												</li>
												<li>
													<a
														href="#"
														onClick={handleLogout}
													>
														Sair
													</a>
												</li>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</nav>

					{children}

					<footer className="app-footer">
						<div className="row">
							<div className="col-xs-12">
								<div className="footer-copyright">
									Copyright © {new Date().getFullYear()}{" "}
									Raio-X do Mercado.
								</div>
							</div>
						</div>
					</footer>
				</div>
			</React.Fragment>
		</div>
	);
};

Layout.propTypes = {
	menuActive: PropTypes.string.isRequired,
	pageTitle: PropTypes.string.isRequired,
	enableSearchBar: PropTypes.bool,
	searchPlaceholder: PropTypes.string,
	searchTerm: PropTypes.string,
	searchOnChange: PropTypes.func,
	handleSearch: PropTypes.func,
	children: PropTypes.node,
};

export default Layout;
